<template>
  <Modal
    title="Enterprise Plan"
    :show.sync="visibleProxy"
    :closeOnBackdrop="!isSubmitting"
    :showClose="!isSubmitting"
    size="lg"
  >
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <h4 class="mb-0">Contact Us</h4>

      </div>
    </template>

    <form class="general-form" @submit.prevent="submitForm">
      <p class="mb-0 text-danger text-center text-sm">* contact us for Enterprise Plan more then 2500 users</p>
      <div class="row">
        <div class="col-md-6">
          <label class="form-control-label fw-bold">
            First Name<span class="requireField">*</span>
          </label>
          <base-input
            type="text"
            v-model="form.firstName"
            placeholder="Enter your first name"
          />
          <small v-if="formErrors.first_name" class="text-danger">
            {{ formErrors.first_name[0] }}
          </small>
        </div>

        <div class="col-md-6">
          <label class="form-control-label fw-bold">
            Last Name<span class="requireField">*</span>
          </label>
          <base-input
            type="text"
            v-model="form.lastName"
            placeholder="Enter your last name"
          />
          <small v-if="formErrors.last_name" class="text-danger">
            {{ formErrors.last_name[0] }}
          </small>
        </div>

        <div class="col-md-6">
          <label class="form-control-label fw-bold">
            Email Address<span class="requireField">*</span>
          </label>
          <base-input
            type="email"
            v-model="form.email"
            placeholder="Enter your email address"
          />
          <small v-if="formErrors.email" class="text-danger">
            {{ formErrors.email[0] }}
          </small>
        </div>

        <div class="col-md-6">
          <label class="form-control-label fw-bold">
            Company Name<span class="requireField">*</span>
          </label>
          <base-input
            type="text"
            v-model="form.company"
            placeholder="Enter your company name"
          />
          <small v-if="formErrors.company" class="text-danger">
            {{ formErrors.company[0] }}
          </small>
        </div>

        <div class="col-md-12">
          <label class="form-control-label fw-bold">
            Message<span class="requireField">*</span>
          </label>
          <textarea
            v-model="form.message"
            class="form-control"
            placeholder="Enter your message"
            rows="4"
          ></textarea>
          <small v-if="formErrors.message" class="text-danger">
            {{ formErrors.message[0] }}
          </small>
        </div>
      </div>

      <base-button
        native-type="submit"
        type="primary"
        class="mt-4 primary-orange border-0 w-100 rounded-3 fw-bold"
        :loading="isSubmitting"
        :disabled="isSubmitting"
        style="padding: 10px 20px;"
      >
        Submit
      </base-button>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "EnterprisePlanModal",
  components: { Modal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      isSubmitting: false,
      feedbackMessage: "",
      formErrors: {},
      form: {
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        message: "",
      },
    };
  },
  computed:{
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },
  methods: {

    handleClose() {
      this.$emit("close");
      this.resetForm();
    },
    resetForm() {
      this.form = {
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        message: "",
      };
      this.formErrors = {};
    },
    async submitForm() {
      this.isSubmitting = true;
      this.formErrors = {};
      const payload = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        email: this.form.email,
        company: this.form.company,
        message: this.form.message,
      };

      try {
        const { data } = await this.$http.post("/user/send-enterprise-plan-request", payload);
        this.$toast?.success(data.message, { timeout: 5000 });
        this.resetForm();
        this.$emit("close")
        await this.$router.push("/");
      } catch (error) {
        console.log(JSON.parse(JSON.stringify(error)));
        if (error.response?.status === 422) {
          this.formErrors = error.response.data || {};
          console.log(this.formErrors);
        } else {
          this.$toast?.error("Something went wrong. Please try again.", { timeout: 5000 });
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.live-chat,
.demo-card {
  border-radius: 15px;
  background: #fff;
  border: 1px solid rgba(235, 26, 38, 0.2);
}
.demo-card {
  background: rgba(232, 83, 47, 0.03);
  color: rgba(255, 255, 255, 0.9);
  padding: 22px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;

.demo-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.demo-text h4 {
  margin: 0;
  font-size: 16px;
  line-height: 18px;
  font-weight: 700;
  color: rgba(234, 37, 39, 1);
}

.demo-cta .schedule-btn {
  background: transparent;
  border: 1px solid rgba(234, 37, 39, 1);
  color: rgba(234, 37, 39, 1);
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
}
}
@media (min-width: 1024px) {
  .demo-card {
    background: rgba(232, 83, 47, 0.03);
    color: rgba(255, 255, 255, 0.9);
    padding: 22px 20px;
    border-radius: 12px;
    display: flex;
    align-items: center;

    .demo-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .demo-text h4 {
      margin: 0;
      font-size: 16px;
      line-height: 18px;
      font-weight: 700;
      color: rgba(234, 37, 39, 1);
    }

    .demo-cta .schedule-btn {
      background: transparent;
      border: 1px solid rgba(234, 37, 39, 1);
      color: rgba(234, 37, 39, 1);
      padding: 8px 12px;
      border-radius: 10px;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
    }
  }
}
</style>
